export default __webpack_public_path__ + "static/media/image2.97f2b9e2.svg";